import { render, staticRenderFns } from "./AddTeamLesson.vue?vue&type=template&id=da5057ec&"
import script from "./AddTeamLesson.vue?vue&type=script&lang=js&"
export * from "./AddTeamLesson.vue?vue&type=script&lang=js&"
import style0 from "./AddTeamLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddTeamLesson.vue"
export default component.exports